import type { FC, PropsWithChildren } from 'react';

import { numberedListStyle } from './NumberedList.css';
import { getClassNames } from '../../util/css';

type CompoundNumberedListProps = {
  Item: typeof Item;
};

export const NumberedList: FC<PropsWithChildren<{ className?: string }>> & CompoundNumberedListProps = ({
  children,
  className,
}) => {
  const classNames = getClassNames(numberedListStyle, className);
  return <ol className={classNames}>{children}</ol>;
};

const Item: FC<PropsWithChildren> = ({ children }) => {
  return <li>{children}</li>;
};

NumberedList.Item = Item;
